namespace Gamification.Gamification {
    export interface ProdottiClassiForm {
        IdentifierClasse: Serenity.StringEditor;
        Nome: Serenity.StringEditor;
        Descrizione: Serenity.TextAreaEditor;
    }

    export class ProdottiClassiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ProdottiClassi';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProdottiClassiForm.init)  {
                ProdottiClassiForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;

                Q.initFormType(ProdottiClassiForm, [
                    'IdentifierClasse', w0,
                    'Nome', w0,
                    'Descrizione', w1
                ]);
            }
        }
    }
}
